import Navbar from "../components/Landing/Navbar"
import { Fragment } from "react"
import AcademyList from "src/components/Academy/AcademyList"
const AcademyHomePage = () => {

  return (
    <Fragment>
      <Navbar />
      <div style={{background:"linear-gradient(45deg, white,#f2f2f2)"}} className="w-full">
        <section className="pt-0 pb-28 mx-auto ">
          <AcademyList type={'home'} />
        </section>
      </div>
    </Fragment>
  )
}
export default AcademyHomePage